"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const component_1 = require("@festival/component");
const react_mobx_store_container_1 = require("react-mobx-store-container");
const react_router_dom_1 = require("react-router-dom");
const not_found_1 = require("@festival/page/not-found");
const store_factory_1 = require("@festival/activity/store-factory");
const store_factory_2 = require("@festival/tag/store-factory");
const store_factory_3 = require("@festival/guest/store-factory");
const list_1 = require("@festival/activity/list");
const show_1 = require("@festival/activity/show");
class Home extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.pageConfigurationStore) {
            this.props.pageConfigurationStore.setCurrent('activities');
        }
    }
    render() {
        const { routeManager } = this.props;
        if (!routeManager) {
            return;
        }
        return (React.createElement(component_1.DynamicModule, { name: "activity", extensions: this.extensions },
            React.createElement(react_mobx_store_container_1.DynamicProvider, { names: [store_factory_2.factory, store_factory_1.factory, store_factory_3.factory] },
                React.createElement(react_router_dom_1.Switch, null,
                    React.createElement(react_router_dom_1.Route, { path: routeManager.generate('activity-show'), exact: true, component: show_1.default }),
                    React.createElement(react_router_dom_1.Route, { path: routeManager.generate('activities'), exact: true, component: list_1.default }),
                    React.createElement(react_router_dom_1.Route, { component: not_found_1.default })))));
    }
    get extensions() {
        return ['/tag'];
    }
}
exports.Home = Home;
exports.default = mobx_react_1.inject('routeManager', 'pageConfigurationStore')(mobx_react_1.observer(Home));
